import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { PartnerForm } from "@modules/partners/components";
import { usePartnerCreateForm } from "./controller";

export const PartnerCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = usePartnerCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <PartnerForm />
      </FormProvider>
    </Create>
  );
});
